/* Import Estilo */
import "./index.scss";
import "../../../../css/global.css";
import "../../../../css/normalize.css";

/* Import Bibliotecas */
import { useEffect, useState, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import axios from "axios";

/* Import Componentes */
import Cabecalho from "../../../../components/Cabecalho/index.js";
import Rodape from "../../../../components/Rodape/index.js";
import CookieAceite from "../../../../components/CookieAceite/index.js";
import BtnVoltar from "../../../../components/bntVoltar/index.js";
import MenuLateral from "../../../../components/MenuLateral/index.js";
import {
  validadorCPF,
  validadorCNPJ,
  validadorEmail,
  validadorNomeCompleto,
  validadorNumeroCelular,
  validadorDataNascimento,
  removerCaracteresEspeciais,
  converterDataParaYMD,
  formatadorCPF,
  formatadorCNPJ,
  formatadorNumeroCelular,
} from "../../../../utils/Validadores/index.js";

/* Import Requisição API */
import api from "../../../../api.js";
import MapComponent from "../../../../components/MapComponet/index.js";

export default function VisualizarCliente() {
  const [usuario_id, setIdUsuario] = useState();
  const [clientes, setClientes] = useState("");
  const [nome, setNome] = useState("");
  const [cpfCnpj, setCpfCnpj] = useState("");
  const [email, setEmail] = useState("");
  const [celular, setCelular] = useState("");
  const [dataNascimento, setDataNascimento] = useState("");
  const [sexo, setSexo] = useState("");
  const [nivel, setNivel] = useState("");
  const [isCNPJ, setIsCNPJ] = useState(false);
  const [razaoSocial, setRazaoSocial] = useState("");
  const [inscricaoEstadual, setInscricaoEstadual] = useState("");
  const [inscricaoMunicipal, setInscricaoMunicipal] = useState("");
  const [telefone, setTelefone] = useState("");
  const [statusCliente, setStatusCliente] = useState("");
  const [texto, setTexto] = useState("");
  const [id_cliente, setIdCliente] = useState("");
  const [idClienteParaExcluir, setIdClienteParaExcluir] = useState(null);
  const [modalAberto, setModalAberto] = useState(false);
  const [excluindo, setExcluindo] = useState(false);
  const [pedidos, setPedidos] = useState([]);
  const [carregandoPedidos, setCarregandoPedidos] = useState(false);
  const [pesquisaPedidos, setPesquisaPedidos] = useState("");
  const [itensCarrinho, setItensCarrinho] = useState([]);
  const [carregandoCarrinho, setCarregandoCarrinho] = useState(false);
  const location = useLocation();
  const id = location.state?.id;

  const [cep, setCep] = useState("");
  const [logradouro, setLogradouro] = useState("");
  const [numero, setNumero] = useState("");
  const [complemento, setComplemento] = useState("");
  const [bairro, setBairro] = useState("");
  const [cidade, setCidade] = useState("");
  const [estado, setEstado] = useState("");

  const [userLocation, setUserLocation] = useState(null); // Localização do usuário
  const [destination, setDestination] = useState(null);

  const caixaDeDialogo = useRef(null);

  const navigate = useNavigate();

  const corrigirAcentuacao = (valor) => {
    if (valor === null || valor === undefined) return "";

    let texto = String(valor).trim();
    if (!texto) return "";

    if (/[ÃÂ]/.test(texto)) {
      try {
        texto = decodeURIComponent(escape(texto));
      } catch {
        // Mantem o texto original se a correção não for possível
      }
    }

    const correcoesComuns = {
      "S�o": "São",
      "N�o": "Não",
      "n�o": "não",
      "Jo�o": "João",
      "A�": "Aí",
      "Cora��o": "Coração",
      "P�o": "Pão",
    };

    Object.entries(correcoesComuns).forEach(([quebrado, correto]) => {
      texto = texto.replaceAll(quebrado, correto);
    });

    return texto;
  };

  const valorOuTraco = (valor) => {
    const texto = corrigirAcentuacao(valor);
    return texto || "-";
  };

  const formatarMoeda = (valor) => {
    const numero = Number(valor);
    if (Number.isNaN(numero)) return "-";

    return numero.toLocaleString("pt-BR", {
      style: "currency",
      currency: "BRL",
    });
  };

  const montarDescricaoVariacao = (item) => {
    const partes = [item.cor, item.tamanho, item.material, item.tipo]
      .map((parte) => (parte ? String(parte).trim() : ""))
      .filter(Boolean);

    return partes.length > 0 ? partes.join(" | ") : "Variação padrão";
  };

  useEffect(() => {
    caixaDeDialogo.current = document.getElementById("CaixaDeDialogo");
  }, []);

  const abrirModalExcluir = (id_cliente) => {
    setIdClienteParaExcluir(id_cliente);
    setModalAberto(true);
    caixaDeDialogo.current?.showModal();
  };

  const fecharModal = () => {
    setModalAberto(false);
    caixaDeDialogo.current?.close();
    setIdClienteParaExcluir(null);
  };

  const confirmarExcluirCliente = async () => {
    try {
      setExcluindo(true);
      await api.delete(`/clientes/${idClienteParaExcluir}`, {
        data: { usuario_id },
      });
      setClientes((prev) =>
        prev.filter((cliente) => cliente.id !== idClienteParaExcluir)
      );
      fecharModal();
    } catch (error) {
      console.error("Erro ao excluir cliente:", error);
    } finally {
      setExcluindo(false);
    }
  };

  const handleEdit = (id) =>
    navigate("/menu/clientes/editarcliente", { state: { id } });

  useEffect(() => {
    if (!id) return;

    const buscarCliente = async () => {
      try {
        const response = await api.get(`/clientes/${id}`);
        const cliente = response.data.cliente;

        if (!cliente) {
          console.error("Cliente não encontrado.");
          return;
        }

        // Formata CPF/CNPJ
        const cpfCnpjFormatado =
          cliente.cpf_cnpj.length === 11
            ? formatadorCPF(cliente.cpf_cnpj)
            : formatadorCNPJ(cliente.cpf_cnpj);

        const ehCNPJ = cliente.cpf_cnpj.length === 14;
        
        setNome(cliente.nome);
        setCpfCnpj(cpfCnpjFormatado);
        setEmail(cliente.email);
        setNivel(cliente.nivel_acesso);
        setCelular(formatadorNumeroCelular(cliente.celular));
        setIdCliente(cliente.id);
        setDataNascimento(
          cliente.data_nascimento
            ? new Date(cliente.data_nascimento).toLocaleDateString("pt-BR")
            : ""
        );
        setSexo(cliente.sexo);
        setIsCNPJ(ehCNPJ);
        setRazaoSocial(cliente.razao_social || "");
        setInscricaoEstadual(cliente.inscricao_estadual || "");
        setInscricaoMunicipal(cliente.inscricao_municipal || "");
        setTelefone(formatadorNumeroCelular(cliente.telefone));
        setStatusCliente(cliente.status_cliente || "");

        // Aqui, assume que cliente.enderecos é um array
        const enderecos = cliente.enderecos || [];

        if (enderecos.length === 0) {
          console.warn("Cliente não possui endereços cadastrados.");
          // Limpa campos do endereço
          setCep("");
          setLogradouro("");
          setNumero("");
          setComplemento("");
          setBairro("");
          setCidade("");
          setEstado("");
          return;
        }

        // Suponha que você quer o primeiro endereço como principal
        const endereco = enderecos[0];

        setCep(endereco.cep || "");
        setLogradouro(endereco.logradouro || "");
        setNumero(endereco.numero || "");
        setComplemento(endereco.complemento || "");
        setBairro(endereco.bairro || "");
        setCidade(endereco.cidade || "");
        setEstado(endereco.estado || "");

        // Verifica se dados do endereço são suficientes para geocodificação
        if (
          !endereco.logradouro ||
          !endereco.numero ||
          !endereco.bairro ||
          !endereco.cidade ||
          !endereco.estado
        ) {
          console.warn("Endereço incompleto para geocodificação.");
          return;
        }

        const enderecoCompleto = `${endereco.logradouro}, ${endereco.numero}, ${endereco.bairro}, ${endereco.cidade}, ${endereco.estado}, Brasil`;
        const geocodeUrl = `/geocode?endereco=${encodeURIComponent(enderecoCompleto)}`;

        const res = await api.get(geocodeUrl);

        if (res.data && res.data.length > 0) {
          const lat = parseFloat(res.data[0].lat);
          const lon = parseFloat(res.data[0].lon);
          setDestination({ lat, lng: lon });
        } else {
          console.warn("Endereço não encontrado na geocodificação.");
        }
      } catch (error) {
        console.error("Erro ao carregar dados do cliente ou geocodificar:", error);
      }
    };

    buscarCliente();
  }, [id]);

  // Carregar pedidos do cliente
  useEffect(() => {
    if (!id) return;

    const buscarPedidosCliente = async () => {
      try {
        setCarregandoPedidos(true);
        const response = await api.get(`/cliente/${id}/pedidos`);
        if (response.data.success) {
          setPedidos(response.data.pedidos || []);
        }
      } catch (error) {
        console.error("Erro ao carregar pedidos do cliente:", error);
        setPedidos([]);
      } finally {
        setCarregandoPedidos(false);
      }
    };

    buscarPedidosCliente();
  }, [id]);

  useEffect(() => {
    if (!id && !id_cliente) return;

    const buscarCarrinhoCliente = async () => {
      try {
        setCarregandoCarrinho(true);
        const idsParaTestar = [id_cliente, id]
          .map((valor) => Number(valor))
          .filter((valor, indice, arr) => Number.isInteger(valor) && valor > 0 && arr.indexOf(valor) === indice);

        let itens = [];

        for (const idUsuario of idsParaTestar) {
          const response = await api.get(`/carrinho/${idUsuario}`);
          if (response.data?.success && Array.isArray(response.data.data) && response.data.data.length > 0) {
            itens = response.data.data;
            break;
          }

          if (response.data?.success && Array.isArray(response.data.data) && itens.length === 0) {
            itens = response.data.data;
          }
        }

        setItensCarrinho(itens);
      } catch (error) {
        console.error("Erro ao carregar carrinho do cliente:", error);
        setItensCarrinho([]);
      } finally {
        setCarregandoCarrinho(false);
      }
    };

    buscarCarrinhoCliente();
  }, [id, id_cliente]);

  const pedidosFiltrados = pedidos.filter((pedido) =>
    pedido.id.toString().includes(pesquisaPedidos.toLowerCase()) ||
    new Date(pedido.criado_em).toLocaleDateString("pt-BR").includes(pesquisaPedidos)
  );

  const handleViewPedido = (pedidoId) => {
    navigate("/menu/pedidos/visualizarpedido", { state: { id: pedidoId } });
  };

  const handleEditPedido = (pedidoId) => {
    navigate("/menu/pedidos/editarpedido", { state: { id: pedidoId } });
  };

  const handleCriarPedido = () => {
    navigate("/menu/pedidos/cadastropedido");
  };

  const handleCriarPedidoComCarrinho = () => {
    if (!id_cliente || itensCarrinho.length === 0) return;

    const carrinhoInicial = itensCarrinho.map((item) => ({
      id_variacao: item.id_variacao,
      id_produto: item.id_produto,
      nome_produto: item.nome,
      nome: montarDescricaoVariacao(item),
      preco: Number(item.preco) || 0,
      unidades_por_pacote: Number(item.unidades_por_pacote) || 1,
      cor: item.cor || "",
      tamanho: item.tamanho || "",
      material: item.material || "",
      tipo: item.tipo || "",
      quantidade: Number(item.quantidade) || 1,
      imagem: item.imagem_principal || null,
    }));

    navigate("/menu/pedidos/cadastropedido", {
      state: {
        idCliente: id_cliente,
        carrinhoInicial,
      },
    });
  };

  const celularWhatsApp = celular.replace(/\D/g, "");
  const linkWhatsApp = celularWhatsApp
    ? `https://wa.me/55${celularWhatsApp}`
    : "#";
  const quantidadeItensCarrinho = itensCarrinho.reduce(
    (acc, item) => acc + (Number(item.quantidade) || 0),
    0
  );
  const subtotalCarrinho = itensCarrinho.reduce(
    (acc, item) => acc + (Number(item.preco) || 0) * (Number(item.quantidade) || 0),
    0
  );
  const totalCarrinho = subtotalCarrinho;

  return (
    <section className="container-principal-visualizarCliente">
      <dialog id="CaixaDeDialogo">
        <div className="conteudo-dialog">
          <div className="dialog-texto">
            <p>{texto}</p>
            <button onClick={fecharModal}>Ok</button>
          </div>
        </div>
      </dialog>

      <Cabecalho />
      <CookieAceite />
      <main className="main-visualizarCliente">
        <MenuLateral />
        <section className="conteudo-visualizarCliente">
          <div className="titulo-visualizarCliente">
            <h1>
              <span>Clientes</span> &gt; Visualizar Cliente
            </h1>
          </div>
          <BtnVoltar />
          <div className="detalhes-cliente">
            <div className="conteudo-DescricaoCliente">
              <div className="cabecalho-DescricaoClienteTitulo">
                <h2>Dados do Cliente</h2>
              </div>
              <div className="dados-DescricaoCliente">
                <div className="dadoDuplo">
                  <div className="dado">
                    <strong>Nome:</strong>
                    <p>{valorOuTraco(nome)}</p>
                  </div>
                  <div className="dado">
                    <strong>CPF/CNPJ:</strong>
                    <p>{valorOuTraco(cpfCnpj)}</p>
                  </div>
                </div>
                <div className="dadoDuplo">
                  <div className="dado">
                    <strong>Email:</strong>
                    <p>{valorOuTraco(email)}</p>
                  </div>
                  <div className="dado">
                    <strong>Celular:</strong>
                    <p>{valorOuTraco(celular)}</p>
                  </div>
                </div>
                <div className="dadoDuplo">
                  <div className="dado">
                    <strong>Telefone Fixo:</strong>
                    <p>{valorOuTraco(telefone)}</p>
                  </div>
                </div>
                {isCNPJ && (
                  <div className="dadoDuplo">
                    <div className="dado">
                      <strong>Razão Social:</strong>
                      <p>{valorOuTraco(razaoSocial)}</p>
                    </div>
                  </div>
                )}
                {isCNPJ && (
                  <div className="dadoDuplo">
                    <div className="dado">
                      <strong>Inscrição Estadual:</strong>
                      <p>{valorOuTraco(inscricaoEstadual)}</p>
                    </div>
                    <div className="dado">
                      <strong>Inscrição Municipal:</strong>
                      <p>{valorOuTraco(inscricaoMunicipal)}</p>
                    </div>
                  </div>
                )}
                <div className="dadoDuplo">
                  <div className="dado">
                    <strong>Data de nascimento:</strong>
                    <p>{valorOuTraco(dataNascimento)}</p>
                  </div>
                  <div className="dado">
                    <strong>Sexo:</strong>
                    <p>{valorOuTraco(sexo)}</p>
                  </div>
                  <div className="dado">
                    <strong>Perfil:</strong>
                    <p>{valorOuTraco(nivel)}</p>
                  </div>
                </div>
                <div className="dadoDuplo">
                  <div className="dado">
                    <strong>Status:</strong>
                    <p>{valorOuTraco(statusCliente)}</p>
                  </div>
                </div>
                <div className="bnt-acoes">
                  <a href={linkWhatsApp} target="_blank" rel="noopener noreferrer" className={`botao-whatsapp ${!celularWhatsApp ? "disabled" : ""}`}> <svg width="39" height="39" viewBox="0 0 39 39" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M32.7188 6.20635C30.9995 4.4703 28.9519 3.09379 26.6953 2.15703C24.4387 1.22027 22.0183 0.742007 19.575 0.750101C9.3375 0.750101 0.99375 9.09385 0.99375 19.3314C0.99375 22.6126 1.85625 25.8001 3.46875 28.6126L0.84375 38.2501L10.6875 35.6626C13.4063 37.1439 16.4625 37.9313 19.575 37.9313C29.8125 37.9313 38.1563 29.5876 38.1563 19.3501C38.1563 14.3814 36.225 9.7126 32.7188 6.20635ZM19.575 34.7813C16.8 34.7813 14.0812 34.0314 11.7 32.6251L11.1375 32.2876L5.2875 33.8251L6.84375 28.1251L6.46875 27.5439C4.92665 25.0821 4.10798 22.2362 4.10625 19.3314C4.10625 10.8189 11.0437 3.88135 19.5562 3.88135C23.6812 3.88135 27.5625 5.49385 30.4688 8.41885C31.908 9.85109 33.0486 11.5549 33.8243 13.4313C34.6 15.3078 34.9954 17.3196 34.9875 19.3501C35.025 27.8626 28.0875 34.7813 19.575 34.7813ZM28.05 23.2314C27.5812 23.0064 25.2937 21.8814 24.8812 21.7126C24.45 21.5626 24.15 21.4876 23.8313 21.9376C23.5125 22.4064 22.6312 23.4564 22.3687 23.7564C22.1062 24.0751 21.825 24.1126 21.3562 23.8689C20.8875 23.6439 19.3875 23.1376 17.625 21.5626C16.2375 20.3251 15.3187 18.8064 15.0375 18.3376C14.775 17.8689 15 17.6251 15.2437 17.3814C15.45 17.1751 15.7125 16.8376 15.9375 16.5751C16.1625 16.3126 16.2563 16.1064 16.4063 15.8064C16.5563 15.4876 16.4812 15.2251 16.3687 15.0001C16.2562 14.7751 15.3187 12.4876 14.9437 11.5501C14.5687 10.6501 14.175 10.7626 13.8938 10.7439H12.9937C12.675 10.7439 12.1875 10.8564 11.7562 11.3251C11.3437 11.7939 10.1438 12.9189 10.1438 15.2064C10.1438 17.4939 11.8125 19.7064 12.0375 20.0064C12.2625 20.3251 15.3187 25.0126 19.9687 27.0189C21.075 27.5064 21.9375 27.7876 22.6125 27.9939C23.7187 28.3501 24.7313 28.2939 25.5375 28.1814C26.4375 28.0501 28.2937 27.0564 28.6687 25.9689C29.0625 24.8814 29.0625 23.9626 28.9313 23.7564C28.8 23.5501 28.5187 23.4564 28.05 23.2314Z" />
                  </svg>
                    Conversar no WhatsApp </a>
                  <a href={`mailto:${email}`} className="botao-email"><svg width="39" height="31" viewBox="0 0 39 31" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M38.25 4.25C38.25 2.1875 36.5625 0.5 34.5 0.5H4.5C2.4375 0.5 0.75 2.1875 0.75 4.25V26.75C0.75 28.8125 2.4375 30.5 4.5 30.5H34.5C36.5625 30.5 38.25 28.8125 38.25 26.75V4.25ZM34.5 4.25L19.5 13.625L4.5 4.25H34.5ZM34.5 26.75H4.5V8L19.5 17.375L34.5 8V26.75Z" />
                  </svg>
                    Enviar E-mail </a>
                </div>
              </div>
            </div>

            <div className="endereco-cliente">
              <div className="cabecalho-endereco">
                <h2>Endereço do Cliente</h2>
              </div>
              <div className="container-interno-endereco">
                <div className="dados-endereco">
                  <div className="dadoDuplo">
                    <div className="dado">
                      <strong className="titulo">CEP:</strong>
                      <p>{valorOuTraco(cep)}</p>
                    </div>
                    <div className="dado">
                      <strong className="titulo">Número:</strong>
                      <p>{valorOuTraco(numero)}</p>
                    </div>
                  </div>

                  <strong>Logradouro:</strong>
                  <p>{valorOuTraco(logradouro)}</p>

                  <strong>Bairro:</strong>
                  <p>{valorOuTraco(bairro)}</p>

                  <div className="dadoDuplo">
                    <div className="dado">
                      <strong className="titulo">Cidade:</strong>
                      <p>{valorOuTraco(cidade)}</p>
                    </div>
                    <div className="dado">
                      <strong className="titulo">Estado:</strong>
                      <p>{valorOuTraco(estado)}</p>
                    </div>
                  </div>
                  <strong>Complemento:</strong>
                  <p>{valorOuTraco(complemento)}</p>
                </div>
                <div className="mapa">
                  <MapComponent
                    origin={userLocation}
                    destination={destination}
                  />
                </div>
              </div>
            </div>

            <div className="carrinho-cliente">
              <div className="cabecalho-produtos">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M7 18C5.9 18 5.01 18.9 5.01 20C5.01 21.1 5.9 22 7 22C8.1 22 9 21.1 9 20C9 18.9 8.1 18 7 18ZM1 2V4H3L6.6 11.59L5.25 14.04C5.09 14.32 5 14.65 5 15C5 16.1 5.9 17 7 17H19V15H7.42C7.28 15 7.17 14.89 7.17 14.75L7.2 14.63L8.1 13H15.55C16.3 13 16.96 12.59 17.3 11.97L20.88 5.48C20.96 5.34 21 5.17 21 5C21 4.45 20.55 4 20 4H5.21L4.27 2H1ZM17 18C15.9 18 15.01 18.9 15.01 20C15.01 21.1 15.9 22 17 22C18.1 22 19 21.1 19 20C19 18.9 18.1 18 17 18Z" fill="#fff"/>
                </svg>
                Itens no Carrinho do Cliente
              </div>
              <div className="conteudo-produtos">
                <div className="lista-produtos">
                  {carregandoCarrinho ? (
                    <p className="sem-itens">Carregando carrinho...</p>
                  ) : itensCarrinho.length === 0 ? (
                    <p className="sem-itens">Nenhum item no carrinho =(</p>
                  ) : (
                    itensCarrinho.map((item) => {
                      const quantidade = Number(item.quantidade) || 0;
                      const preco = Number(item.preco) || 0;
                      const subtotal = quantidade * preco;
                      const atributos = [];

                      if (item.cor) atributos.push(item.cor);
                      if (item.tamanho) atributos.push(item.tamanho);
                      if (item.tipo) atributos.push(item.tipo);
                      if (item.material) atributos.push(item.material);

                      const descricaoAtributos = atributos.join(" / ");

                      return (
                        <div className="produto-item" key={item.id_variacao || item.id}>
                          <div className="produto-imagem">
                            <img
                              src={item.imagem_principal || "/assets/image/imagemPadrao.svg"}
                              alt={item.nome || "Produto"}
                            />
                          </div>
                          <div className="produto-info">
                            <h4>{valorOuTraco(item.nome)}</h4>
                            {descricaoAtributos && (
                              <p className="item-atributos">{descricaoAtributos}</p>
                            )}
                            <div className="preco-info">
                              <p className="preco-unitario">
                                {formatarMoeda(preco)}
                                {Number(item.unidades_por_pacote) > 1 && (
                                  <span className="preco-unitario-lado"> | Preço/Unit. {formatarMoeda(preco / Number(item.unidades_por_pacote))}</span>
                                )}
                              </p>
                            </div>
                            <p className="item-subtotal">
                              Qtd: {quantidade || "-"}{Number(item.unidades_por_pacote) > 1 ? ` | ${Number(item.unidades_por_pacote)} Unit.` : ""} | Subtotal: {formatarMoeda(subtotal)}
                            </p>
                          </div>
                        </div>
                      );
                    })
                  )}
                </div>

                <div className="resumo-financeiro">
                  <div className="linha-resumo">
                    <span className="label-resumo">Quantidade de Itens:</span>
                    <span className="valor-resumo">{quantidadeItensCarrinho}</span>
                  </div>
                  <div className="linha-resumo">
                    <span className="label-resumo">Subtotal:</span>
                    <span className="valor-resumo">{formatarMoeda(subtotalCarrinho)}</span>
                  </div>
                  <div className="linha-resumo total">
                    <span className="label-resumo">Total:</span>
                    <span className="valor-resumo">{formatarMoeda(totalCarrinho)}</span>
                  </div>
                </div>

                <button
                  className="bnt-criarPedido-carrinho"
                  onClick={handleCriarPedidoComCarrinho}
                  disabled={itensCarrinho.length === 0}
                >
                  Criar Pedido com Itens do Carrinho
                </button>
              </div>
            </div>

            <div className="pedidos-cliente">
              <div className='dados-pedidosCliente'>
                <div className="cabecalho-pedidos">
                  <h2>Pedidos do Cliente</h2>
                </div>
                <div className='conteudo-pedidosCliente'>
                  <div className='barraDePesquisa-e-cadastroPedido-container'>
                    <div className='barraDePesquisa-pedidos'>
                      <svg
                        width="31"
                        height="31"
                        viewBox="0 0 31 31"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M19.6667 19.6667L28 28M12.7222 22.4444C11.4455 22.4444 10.1812 22.193 9.00169 21.7044C7.82213 21.2158 6.75036 20.4997 5.84757 19.5969C4.94478 18.6941 4.22865 17.6223 3.74006 16.4428C3.25147 15.2632 3 13.999 3 12.7222C3 11.4455 3.25147 10.1812 3.74006 9.00169C4.22865 7.82213 4.94478 6.75036 5.84757 5.84757C6.75036 4.94478 7.82213 4.22865 9.00169 3.74006C10.1812 3.25147 11.4455 3 12.7222 3C15.3007 3 17.7736 4.0243 19.5969 5.84757C21.4201 7.67084 22.4444 10.1437 22.4444 12.7222C22.4444 15.3007 21.4201 17.7736 19.5969 19.5969C17.7736 21.4201 15.3007 22.4444 12.7222 22.4444Z"
                          stroke="#131C46"
                          strokeWidth="4.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                      <input
                        type="text"
                        placeholder="Pesquise o pedido pelo: ID ou Data"
                        value={pesquisaPedidos}
                        onChange={(e) => setPesquisaPedidos(e.target.value)}
                      />
                    </div>
                    <button
                      className='bnt-criarPedido'
                      onClick={handleCriarPedido}
                    >
                      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M10 4.16667V15.8333M4.16667 10H15.8333" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
                      </svg>
                      Criar Pedido
                    </button>
                  </div>
                  <div className="container-interno-pedidos">
                    {carregandoPedidos ? (
                      <p className='carregando-pedidos'>Carregando pedidos...</p>
                    ) : pedidosFiltrados.length === 0 ? (
                      <p className='nenhum-pedido'>Nenhum pedido encontrado =(</p>
                    ) : (
                      <table className="tabela-pedidos">
                        <thead>
                          <tr>
                            <th>ID Pedido</th>
                            <th>Data</th>
                            <th>Total</th>
                            <th className="th-status">Status</th>
                            <th className="th-pagamento">Pagamento</th>
                            <th></th>
                          </tr>
                        </thead>
                        <tbody>
                          {pedidosFiltrados.map((pedido) => (
                            <tr className="conteudo" key={pedido.id}>
                              <td className="primeiro">#{pedido.id}</td>
                              <td>
                                {pedido.criado_em
                                  ? new Date(pedido.criado_em).toLocaleDateString(
                                      "pt-BR"
                                    )
                                  : "-"}
                              </td>
                              <td>{formatarMoeda(pedido.total)}</td>
                              <td className="td-status">{valorOuTraco(pedido.status)}</td>
                              <td className="td-pagamento">{valorOuTraco(pedido.status_pagamento || "Pendente")}</td>
                              <td className="final">
                                <div className="bnts-pedidos">
                                  <button
                                    className="bnt-visualizar"
                                    onClick={() => handleViewPedido(pedido.id)}
                                  >
                                    <svg
                                      width="20"
                                      height="20"
                                      viewBox="0 0 20 20"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        d="M8.4375 6.5625C8.4375 6.31527 8.51081 6.0736 8.64817 5.86804C8.78552 5.66248 8.98074 5.50226 9.20915 5.40765C9.43756 5.31304 9.68889 5.28829 9.93137 5.33652C10.1738 5.38475 10.3966 5.5038 10.5714 5.67862C10.7462 5.85343 10.8653 6.07616 10.9135 6.31864C10.9617 6.56111 10.937 6.81245 10.8424 7.04085C10.7477 7.26926 10.5875 7.46449 10.382 7.60184C10.1764 7.73919 9.93473 7.8125 9.6875 7.8125C9.35598 7.8125 9.03804 7.6808 8.80362 7.44638C8.5692 7.21196 8.4375 6.89402 8.4375 6.5625ZM18.4375 10C18.4375 11.6688 17.9427 13.3001 17.0155 14.6876C16.0884 16.0752 14.7706 17.1566 13.2289 17.7952C11.6871 18.4338 9.99064 18.6009 8.35393 18.2754C6.71721 17.9498 5.2138 17.1462 4.03379 15.9662C2.85379 14.7862 2.05019 13.2828 1.72463 11.6461C1.39907 10.0094 1.56616 8.31286 2.20477 6.77111C2.84338 5.22936 3.92484 3.9116 5.31238 2.98448C6.69992 2.05735 8.33122 1.5625 10 1.5625C12.237 1.56498 14.3817 2.45473 15.9635 4.03653C17.5453 5.61833 18.435 7.763 18.4375 10ZM16.5625 10C16.5625 8.70206 16.1776 7.43327 15.4565 6.35407C14.7354 5.27487 13.7105 4.43374 12.5114 3.93704C11.3122 3.44034 9.99272 3.31038 8.71972 3.5636C7.44672 3.81681 6.2774 4.44183 5.35962 5.35961C4.44183 6.27739 3.81682 7.44672 3.5636 8.71972C3.31039 9.99272 3.44034 11.3122 3.93704 12.5114C4.43374 13.7105 5.27488 14.7354 6.35407 15.4565C7.43327 16.1776 8.70206 16.5625 10 16.5625C11.7399 16.5606 13.408 15.8686 14.6383 14.6383C15.8686 13.408 16.5606 11.7399 16.5625 10ZM10.9375 12.8656V10.3125C10.9375 9.8981 10.7729 9.50067 10.4799 9.20765C10.1868 8.91462 9.7894 8.75 9.375 8.75C9.1536 8.74967 8.93923 8.82771 8.76986 8.97029C8.60048 9.11287 8.48703 9.3108 8.4496 9.52901C8.41217 9.74722 8.45318 9.97164 8.56536 10.1625C8.67754 10.3534 8.85365 10.4984 9.0625 10.5719V13.125C9.0625 13.5394 9.22712 13.9368 9.52015 14.2299C9.81317 14.5229 10.2106 14.6875 10.625 14.6875C10.8464 14.6878 11.0608 14.6098 11.2302 14.4672C11.3995 14.3246 11.513 14.1267 11.5504 13.9085C11.5878 13.6903 11.5468 13.4659 11.4346 13.275C11.3225 13.0841 11.1464 12.9391 10.9375 12.8656Z"
                                        strokeWidth="0.3"
                                      />
                                    </svg>
                                  </button>
                                  <button
                                    className="bnt-editar"
                                    onClick={() => handleEditPedido(pedido.id)}
                                  >
                                    <svg
                                      width="20"
                                      height="20"
                                      viewBox="0 0 20 20"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        d="M12.4999 5.00007L14.9999 7.50007M10.8333 16.6667H17.4999M4.16659 13.3334L3.33325 16.6667L6.66659 15.8334L16.3216 6.17841C16.634 5.86586 16.8096 5.44201 16.8096 5.00007C16.8096 4.55813 16.634 4.13429 16.3216 3.82174L16.1783 3.67841C15.8657 3.36596 15.4419 3.19043 14.9999 3.19043C14.558 3.19043 14.1341 3.36596 13.8216 3.67841L4.16659 13.3334Z"
                                        strokeWidth="2.08333"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                      />
                                    </svg>
                                  </button>
                                </div>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    )}
                  </div>
                </div>
              </div>
            </div>
          
          </div>
          <div className="bnts-produtos">
            <button
              className="bnt-editar"
              onClick={() => handleEdit(id_cliente)}
            >
              <svg
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                {" "}
                <path
                  d="M12.4999 5.00007L14.9999 7.50007M10.8333 16.6667H17.4999M4.16659 13.3334L3.33325 16.6667L6.66659 15.8334L16.3216 6.17841C16.634 5.86586 16.8096 5.44201 16.8096 5.00007C16.8096 4.55813 16.634 4.13429 16.3216 3.82174L16.1783 3.67841C15.8657 3.36596 15.4419 3.19043 14.9999 3.19043C14.558 3.19043 14.1341 3.36596 13.8216 3.67841L4.16659 13.3334Z"
                  stroke-width="2.08333"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
              Editar Cliente
            </button>
            <button
              className="bnt-excluir"
              onClick={() => abrirModalExcluir(id_cliente)}
            >
              <svg
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                {" "}
                <path
                  d="M11.6666 9.16667V14.1667M8.33325 9.16667V14.1667M4.99992 5.83333V15.8333C4.99992 16.2754 5.17551 16.6993 5.48807 17.0118C5.80063 17.3244 6.22456 17.5 6.66659 17.5H13.3333C13.7753 17.5 14.1992 17.3244 14.5118 17.0118C14.8243 16.6993 14.9999 16.2754 14.9999 15.8333V5.83333M3.33325 5.83333H16.6666M5.83325 5.83333L7.49992 2.5H12.4999L14.1666 5.83333"
                  stroke-width="2.08333"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
              Excluir Cliente
            </button>
          </div>
        </section>
      </main>
      <Rodape />
    </section>
  );
}
